import PropTypes from 'prop-types';
import MenuLink from '../MenuLink';

import styles from './DesktopMenuSubmenu.module.scss';
import { MENU } from '@/constants/menu';

const DesktopMenuSubmenu = ({ data, menuLevel1, onClickMenu }) => (
  <div className={styles['desktop-menu-submenu']} data-test-id="desktop-menu-submenu">
    <div className={`row ${styles['no-row-margin']}`}>
      {data.map((title, i) => (
        <div className={`col-${title.colSize ? title.colSize : '4'} ${styles['no-col-padding']}`} key={`title-${i}`}>
          <div className={`${styles['desktop-menu-submenu-title']} tu-title`} data-test-id="desktop-menu-submenu-title">
            <MenuLink
              isMobile={false}
              type={MENU.TITLE}
              link={title}
              handleClick={() => onClickMenu(menuLevel1, title.name)}
            />

            {title.subMenus?.length > 0 && (
              <div className={`row ${styles['no-row-margin']}`}>
                {title.subMenus.map((item, j) => (
                  <div className={`col-12 ${styles['no-col-padding']}`} key={`item-${j}`} data-test-id="desktop-menu-submenu-item">
                    <MenuLink
                      isMobile={false}
                      type={MENU.LIST}
                      link={item}
                      handleClick={() => onClickMenu(menuLevel1, title.name, item.name)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
);

DesktopMenuSubmenu.propTypes = {
  data: PropTypes.array.isRequired,
  menuLevel1: PropTypes.string.isRequired,
  onClickMenu: PropTypes.func.isRequired
};

export default DesktopMenuSubmenu;
